import { Component, OnInit, Inject, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MailWelcome } from '@core/send-mail/mailWelcome';
import { SendMailService } from '@core/send-mail/send-mail.service';
import { environment } from '@envs/environment';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-modal-check-email',
  standalone: true,
  imports: [TranslateModule, MatDialogModule, NgIf],
  templateUrl: './modal-check-email.component.html',
  styleUrl: './modal-check-email.component.scss',
})
export class ModalCheckEmailComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<ModalCheckEmailComponent>);
  private readonly translate = inject(TranslateService);
  private readonly sendMail = inject(SendMailService);
  description: string;
  sendEmail = false;
  url = environment;
  email = '';

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    this.description = data.description;
    this.email = data.mail;
    this.translate.setDefaultLang(data.lang);
  }

  ngOnInit() {}

  resendEmail() {
    var information: MailWelcome = {
      language: localStorage.getItem('language') === 'en' ? 0 : 1,
      email: this.email,
      content: `${this.url.appurl}/${
        localStorage.getItem('language') === 'es'
          ? 'ES/inicio-sesion'
          : 'EN/login'
      }`,
      name: this.email,
      providerAccountId: localStorage.getItem('accountid') || '',
    };
    this.sendMail.SendMailWelcome(information).subscribe(
      (result) => {
        this.sendEmail = !this.sendEmail;
        // this.close();
      },
      (error) => console.log(error)
    );
  }

  save() {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
